/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { ReactComponent as WebpageCardTypeFixed } from "assets/images/icons/components/webpage-card-type-fixed.svg";
import { ReactComponent as WebpageCardTypeFixedSelected } from "assets/images/icons/components/webpage-card-type-fixed-selected.svg";
import { ReactComponent as WebpageCardTypeFill } from "assets/images/icons/components/webpage-card-type-fill.svg";
import { ReactComponent as WebpageCardTypeFillSelected } from "assets/images/icons/components/webpage-card-type-fill-selected.svg";

const WebpageCardType = (props) => {
    
    const { t } = useTranslation();
    const {
        webpageCard = "fixed",
        onChangeCardType,
    } = props || {};
    const isFixed = webpageCard === "fixed";
    const isFill = webpageCard === "fill";
    const fixedIcon = isFixed ? <WebpageCardTypeFixedSelected /> : <WebpageCardTypeFixed />;
    const fillIcon = isFill ? <WebpageCardTypeFillSelected /> : <WebpageCardTypeFill />;
    
    const onChangeWebpageCardHandler = (webpageCard) => {
        onChangeCardType(webpageCard);
    };
    
    return (
        <div className='webpage-card-type-container'>
            <Tooltip
                title={t("commons.webpageFixedDesc")}
                placement='top'
                arrow
                classes={{ arrow: "arrow", tooltip: "tooltip" }}
            >
                <div className='type' onClick={() => onChangeWebpageCardHandler("fixed")}>
                    {fixedIcon}
                </div>
            </Tooltip>
            <Tooltip
                title={t("commons.webpageFillDesc")}
                placement='top'
                arrow
                classes={{ arrow: "arrow", tooltip: "tooltip" }}
            >
                <div className='type' onClick={() => onChangeWebpageCardHandler("fill")}>
                    {fillIcon}
                </div>
            </Tooltip>
        </div>
    );
};

export { WebpageCardType };
